module.exports = __webpack_public_path__ + "static/media/HQ18_Dr-Wallach.10ce3034.png";